import React from 'react';
import Moment from 'react-moment';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { DatePicker } from 'material-ui-pickers';

import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import DoneIcon from '@material-ui/icons/CheckCircle';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

import primaryColor from '@material-ui/core/colors/grey';

import {
  startEditInvoice,
  startEditInvoiceStatuses
} from '../../../store/actions/invoices';

const styles = theme => ({
  root: {
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: primaryColor[100]
  },
  headerContent: {
    padding: '10px 30px 30px 30px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  button: {
    margin: theme.spacing.unit,
  },
  doneIcon: {
    paddingLeft: '5px',
  },
  labelField: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
  },
  address: {
    display: 'flex',
    flexDirection: 'column'
  },
  addressSpacer: {
    height: '20px',
  },
});

//TODO:
//1. refactor app to use moment instead of date
//2. replace hack adddress spacer div with correct css
const InvoiceHeader = (props) => {
  const {
    classes,
    invoice,
    client,
    business,
    startEditAdmin,
    startEditInvoice,
    handlePreviewOpen
  } = props;

//onClick={() => startEditInvoiceStatuses(invoice.id, {sent: true})}>
  return(
    <Paper className={classes.header}>
      <div style={{display: 'flex', alignItems: 'center'}}>
        <div style={{ flex: 1,
                      display: 'flex',
                      justifyContent: 'center'
                    }}/>
        <Typography
          variant="title"
          style={{
            flex: 1,
            display: 'flex',
            justifyContent: 'center'
          }}>
          <Moment format="MMMM">{invoice.scheduleDate}</Moment>
          <div style={{paddingLeft: '4px'}}>Invoice</div>
        </Typography>
        <div
          style={{
            flex: 1,
            display: 'flex',
            justifyContent: 'flex-end',
            paddingRight: '15px',
          }}>
          <Button
            color="secondary"
            onClick={handlePreviewOpen}
            className={classes.button}
          >
            Send
          </Button>
          <Button
            color="primary"
            className={classes.button}
            onClick={() => startEditAdmin({invoice: null})}>
            Done
            <DoneIcon className={classes.doneIcon} />
          </Button>
        </div>
      </div>
      <div className={classes.headerContent}>
        <div className={classes.address}>
          <Address classes={classes} data={{title: "From", name: business.companyName, address: business.address}} />
          <div className={classes.addressSpacer}/>
          <Address classes={classes} data={{title: "To", name: client.firstName, address: client.address}} />
        </div>

        <div>
          <div className={classes.labelField}>
            <Typography variant="subheading">Invoice Number:&nbsp;</Typography>
            <Typography variant="subheading">{invoice !== undefined ? invoice.invoiceNumber.toString().padStart(6, "0") : ""}</Typography>
          </div>
          <div className={classes.labelField} style={{paddingTop: '0px'}}>
            <Typography variant="subheading">
              Status:
            </Typography>
            <Typography variant="subheading">
              {invoice.status}
            </Typography>
          </div>
          <div className={classes.labelField}>
            <Typography variant="subheading">Total:&nbsp;&nbsp;</Typography>
            <Typography variant="subheading">${invoice.grandTotal.toFixed(2)}</Typography>
          </div>
          <div className={classes.labelField}>
            <Typography variant="subheading">Balance:&nbsp;&nbsp;</Typography>
            <Typography variant="subheading">${invoice.balance.toFixed(2)}</Typography>
          </div>
          <div className={classes.labelField} style={{paddingTop: '15px'}}>
            <DatePicker
                label="Invoice Date"
                format="MMMM Do YYYY"
                value={invoice.invoiceDate}
                leftArrowIcon={<ArrowBackIcon />}
                rightArrowIcon={<ArrowForwardIcon />}
                onChange={(date) => startEditInvoice(invoice.id, {invoiceDate: date.toDate().getTime()})}
              />
          </div>
          <div className={classes.labelField} style={{paddingTop: '5px'}}>
            <DatePicker
                label="Due Date"
                format="MMMM Do YYYY"
                value={invoice.dueDate}
                leftArrowIcon={<ArrowBackIcon />}
                rightArrowIcon={<ArrowForwardIcon />}
                onChange={(date) => startEditInvoice(invoice.id, {dueDate: date.toDate().getTime()})}
              />
          </div>
        </div>
      </div>
    </Paper>
  );
}

const Address = ({classes, data, client}) =>
  <div>
    <Typography variant="title">
      {data.title}
    </Typography>
    <Typography variant="subheading">
      {data.name.toUpperCase()}
    </Typography>
    <Typography variant="body1">
      {data.address}
    </Typography>
  </div>


const mapDispatchToProps = (dispatch) => ({
  startEditInvoice: (invoiceID, invoice) => dispatch(startEditInvoice(invoiceID, invoice)),
  startEditInvoiceStatuses: (invoiceID, statuses) => dispatch(startEditInvoiceStatuses(invoiceID, statuses))
});

export default compose(
  withStyles(styles),
  connect(null, mapDispatchToProps)
)(InvoiceHeader);



// WEBPACK FOOTER //
// ./src/components/admin/Invoice/InvoiceHeader.jsx